export default [
  {
    "Codes": "1",
    "Stadtteil": "Altstadt",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "48,7",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "21,4",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "65",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-5,8",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,9",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,0",
    "Bauen und Wohnen Neubauquotient  diff": "-12,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "2",
    "Stadtteil": "Innenstadt",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "58",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-12,4",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,0",
    "Bauen und Wohnen Neubauquotient  diff": "-12,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "3",
    "Stadtteil": "Bahnhofsviertel",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "59,3",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "31,9",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "62",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-8,5",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "40,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "2,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,0",
    "Bauen und Wohnen Neubauquotient  diff": "-12,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "4",
    "Stadtteil": "Westend-Süd",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "70,6",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "43,2",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "77",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "6,1",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "49,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "11,0",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "2,1",
    "Bauen und Wohnen Neubauquotient  diff": "-10,6",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "5",
    "Stadtteil": "Westend-Nord",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "54,3",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "27,0",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "77",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "5,9",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "43,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "5,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,2",
    "Bauen und Wohnen Neubauquotient  diff": "-12,5",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "6",
    "Stadtteil": "Nordend-West",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "92,0",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "64,7",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "73",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "2,5",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "44,0",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "5,9",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "12,2",
    "Bauen und Wohnen Neubauquotient  diff": "-0,5",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "7",
    "Stadtteil": "Nordend-Ost",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "150,6",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "123,3",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "65",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-6,1",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "40,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "2,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,1",
    "Bauen und Wohnen Neubauquotient  diff": "-12,6",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "8",
    "Stadtteil": "Ostend",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "48,5",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "21,2",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "64",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-6,5",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "39,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "1,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,0",
    "Bauen und Wohnen Neubauquotient  diff": "-12,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "9",
    "Stadtteil": "Bornheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "120,7",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "93,4",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "64",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-7,0",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,0",
    "Bauen und Wohnen Neubauquotient  diff": "-12,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "10",
    "Stadtteil": "Gutleutviertel",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "65",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-5,9",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "39,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "1,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "3,9",
    "Bauen und Wohnen Neubauquotient  diff": "-8,8",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "11",
    "Stadtteil": "Gallus",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "31,0",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "3,7",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "57",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-13,7",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "32,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-5,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "12,6",
    "Bauen und Wohnen Neubauquotient  diff": "-0,1",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "12",
    "Stadtteil": "Bockenheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "66,1",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "38,8",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "65",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-5,7",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "39,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "1,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "15,1",
    "Bauen und Wohnen Neubauquotient  diff": "2,4",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "13",
    "Stadtteil": "Sachsenhausen-Nord",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "72",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "0,9",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "42,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "4,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "7,4",
    "Bauen und Wohnen Neubauquotient  diff": "-5,4",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "14",
    "Stadtteil": "Sachsenhausen-Süd",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "9,4",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-17,9",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "77",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "6,1",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "47,5",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "9,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "3,1",
    "Bauen und Wohnen Neubauquotient  diff": "-9,6",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "16",
    "Stadtteil": "Oberrad",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "45,9",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "18,5",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "68",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-2,4",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "37,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-0,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,2",
    "Bauen und Wohnen Neubauquotient  diff": "-12,5",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "17",
    "Stadtteil": "Niederrad",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "76,5",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "49,2",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "63",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-7,5",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "36,0",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-2,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,2",
    "Bauen und Wohnen Neubauquotient  diff": "-12,6",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "18",
    "Stadtteil": "Schwanheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "11,5",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-15,8",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "75",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "4,3",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "37,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-1,0",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,5",
    "Bauen und Wohnen Neubauquotient  diff": "-12,2",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "19",
    "Stadtteil": "Griesheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "47,2",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "19,8",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "66",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-4,9",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "28,5",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-9,6",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "5,2",
    "Bauen und Wohnen Neubauquotient  diff": "-7,5",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "20",
    "Stadtteil": "Rödelheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "33,1",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "5,7",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "66",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-4,3",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "3,4",
    "Bauen und Wohnen Neubauquotient  diff": "-9,3",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "21",
    "Stadtteil": "Hausen",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "57,1",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "29,8",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "70",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-0,6",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "35,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-3,0",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "1,2",
    "Bauen und Wohnen Neubauquotient  diff": "-11,5",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "22",
    "Stadtteil": "Praunheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "34,5",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "7,2",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "71",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "0,5",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "36,6",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-1,5",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,8",
    "Bauen und Wohnen Neubauquotient  diff": "-11,9",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "24",
    "Stadtteil": "Heddernheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "67,3",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "40,0",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "70",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-0,2",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "35,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-2,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,0",
    "Bauen und Wohnen Neubauquotient  diff": "-12,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "25",
    "Stadtteil": "Niederursel",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "20,9",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-6,4",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "75",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "4,0",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "36,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-1,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "1,8",
    "Bauen und Wohnen Neubauquotient  diff": "-10,9",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "26",
    "Stadtteil": "Ginnheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "45,9",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "18,6",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "75",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "4,3",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "37,0",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-1,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "2,0",
    "Bauen und Wohnen Neubauquotient  diff": "-10,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "27",
    "Stadtteil": "Dornbusch",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "84,5",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "57,1",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "77",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "6,3",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "42,6",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "4,5",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,4",
    "Bauen und Wohnen Neubauquotient  diff": "-12,3",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "28",
    "Stadtteil": "Eschersheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "43,1",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "15,7",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "76",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "5,1",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "42,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "4,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,7",
    "Bauen und Wohnen Neubauquotient  diff": "-12,0",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "29",
    "Stadtteil": "Eckenheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "69",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-2,1",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "34,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-3,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "11,2",
    "Bauen und Wohnen Neubauquotient  diff": "-1,5",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "30",
    "Stadtteil": "Preungesheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "37,3",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "9,9",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "78",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "7,2",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "34,0",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,4",
    "Bauen und Wohnen Neubauquotient  diff": "-12,3",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "31",
    "Stadtteil": "Bonames",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "40,5",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "13,2",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "73",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "2,3",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "34,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-3,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "21,0",
    "Bauen und Wohnen Neubauquotient  diff": "8,3",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "32",
    "Stadtteil": "Berkersheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "11,5",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-15,9",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "96",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "25,0",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "37,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-0,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "1,7",
    "Bauen und Wohnen Neubauquotient  diff": "-11,0",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "33",
    "Stadtteil": "Riederwald",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "60",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-10,7",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "32,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-5,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "9,8",
    "Bauen und Wohnen Neubauquotient  diff": "-3,0",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "34",
    "Stadtteil": "Seckbach",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "12,4",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-15,0",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "78",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "7,1",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,5",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,0",
    "Bauen und Wohnen Neubauquotient  diff": "-12,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "35",
    "Stadtteil": "Fechenheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "22,2",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-5,2",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "66",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-4,9",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "31,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-6,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "3,7",
    "Bauen und Wohnen Neubauquotient  diff": "-9,0",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "36",
    "Stadtteil": "Höchst",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "29,9",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "2,5",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "70",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-1,0",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "33,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,9",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "1,2",
    "Bauen und Wohnen Neubauquotient  diff": "-11,5",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "37",
    "Stadtteil": "Nied",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "47,9",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "20,6",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "66",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-4,5",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "32,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-6,0",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "5,2",
    "Bauen und Wohnen Neubauquotient  diff": "-7,5",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "38",
    "Stadtteil": "Sindlingen",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "17,2",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-10,1",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "67",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-3,9",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "32,6",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-5,5",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "2,8",
    "Bauen und Wohnen Neubauquotient  diff": "-9,9",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "39",
    "Stadtteil": "Zeilsheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "27,7",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "0,4",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "71",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "0,1",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "33,5",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,6",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "1,9",
    "Bauen und Wohnen Neubauquotient  diff": "-10,9",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "40",
    "Stadtteil": "Unterliederbach",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "25,0",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-2,4",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "71",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "0,8",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "35,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-2,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,5",
    "Bauen und Wohnen Neubauquotient  diff": "-12,2",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "41",
    "Stadtteil": "Sossenheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "25,6",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-1,8",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "70",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-0,2",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "33,5",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,6",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "6,6",
    "Bauen und Wohnen Neubauquotient  diff": "-6,1",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "42",
    "Stadtteil": "Nieder-Erlenbach",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "5,5",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-21,8",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "103",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "32,0",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "43,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "5,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "3,0",
    "Bauen und Wohnen Neubauquotient  diff": "-9,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "43",
    "Stadtteil": "Kalbach-Riedberg",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "17,4",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-9,9",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "105",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "34,0",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "5,6",
    "Bauen und Wohnen Neubauquotient  diff": "-7,1",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "44",
    "Stadtteil": "Harheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "8,6",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-18,8",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "97",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "26,6",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "44,2",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "6,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "82,0",
    "Bauen und Wohnen Neubauquotient  diff": "69,3",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "45",
    "Stadtteil": "Nieder-Eschbach",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "17,9",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-9,5",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "82",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "11,8",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,3",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "1,0",
    "Bauen und Wohnen Neubauquotient  diff": "-11,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "46",
    "Stadtteil": "Bergen-Enkheim",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "14,0",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "-13,3",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "86",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "15,5",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "44,8",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "6,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "0,0",
    "Bauen und Wohnen Neubauquotient  diff": "-12,7",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "47",
    "Stadtteil": "Frankfurter Berg",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "86",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "15,2",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "33,7",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,4",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "2,3",
    "Bauen und Wohnen Neubauquotient  diff": "-10,4",
    "Bauen und Wohnen Neubauquotient  target": ""
  },
  {
    "Codes": "#Frankfurt",
    "Stadtteil": "Frankfurt am Main",
    "Bauen und Wohnen Einwohnerdichte je ha  2012": "27,3",
    "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
    "Bauen und Wohnen Einwohnerdichte je ha  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "71",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "",
    "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,1",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "",
    "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
    "Bauen und Wohnen Neubauquotient  2012": "12,7",
    "Bauen und Wohnen Neubauquotient  diff": "",
    "Bauen und Wohnen Neubauquotient  target": ""
  }
]



// WEBPACK FOOTER //
// ./src/data/stadtteilprofile-bauen-wohnen.js